export default "__VITE_ASSET__Bs1cw2pi__"